import { StyleSheet } from 'react-native';

import type { useTheme } from './theme';

/** Style sheet for the FocusPanel effort block. Extracted from
 *  FocusPanelEffort.tsx (SP-FOCUSPANELEFFORT, 2026-07-27) to get that file
 *  under the 500-line cap; moved verbatim, only widened to `export`. */
export function makeStyles(theme: ReturnType<typeof useTheme>) {
  const { palette: p, spacing: s, radius: r, typography: ty } = theme;
  return StyleSheet.create({
    block: { gap: 4 },
    // ≥44pt tap target independent of the (locale-varying) text height — the
    // shortest questions render one line and would otherwise fall under the
    // floor (a11y audit AP-0j). Centers the question in the axis row.
    questionWrap: {
      minHeight: 44,
      justifyContent: 'center',
      alignItems: 'center',
    },
    questionPressed: { opacity: 0.6 },
    // Compact variant: the word sits at the axis LEFT and takes the free width,
    // so its tap target is wide even though the word is short. The empty
    // axisCenter spacer beside it pushes the gear to the far right.
    wordWrap: { flex: 1, alignItems: 'flex-start' },
    word: { textAlign: 'left' },
    // The question sits centered between Easy and Hard on the axis row (AP-0j).
    // base, not md: prominence comes from WEIGHT (bold) + underline, not size —
    // the Reps/Kg values are md (FocusPanelInputs), the card's hero numbers, so
    // a md question would invert the hierarchy (PRODUCT.md: numbers are the
    // product; Antenore is myopic-corrected, not low-vision → don't inflate).
    question: {
      color: p.ink,
      fontSize: ty.sizes.base,
      fontWeight: '700',
      textDecorationLine: 'underline',
      textAlign: 'center',
    },
    // Fail press-tip bubble — same look as the card logger's HeaderTooltip
    // (moved verbatim from the retired ✗ button's row).
    failBubble: {
      backgroundColor: p.ink,
      borderRadius: r.r2,
      paddingHorizontal: s.s3,
      paddingVertical: s.s2,
    },
    failBubbleText: {
      color: p.bg,
      fontSize: ty.sizes.xs,
      lineHeight: ty.sizes.xs * 1.4,
      fontWeight: '500',
    },
  });
}
